export default __webpack_public_path__ + "static/media/coupe.d4522819.svg";